import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Button, FormLabel, Grid, Input, MenuItem } from '@material-ui/core';
import { postMedia } from '@webapps/business';
import {
  FormikTextField,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const mediaSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  description: yup.string().required('Requis'),
  type: yup.string().required('Requis'),
  path: yup.string(),
  attachment: yup.string(),
  priority: yup.number().required('Requis'),
});

export const TYPES = [
  {
    value: 'image',
    label: 'Fichier image',
  },
  {
    value: 'video',
    label: 'Url video youtube',
  },
];

const CreateMediaForm = ({ close, data, refetch }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateMedia,
  } = useMutation(postMedia);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccess]);

  let counter = 1;
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < data.length; i++) {
    // eslint-disable-next-line no-plusplus
    if (data[i]) counter++;
  }
  if (!data[0]) counter = 0;

  const formik = useFormik({
    initialValues: {
      label: '',
      description: '',
      type: 'video',
      path: '',
      attachment: '',
      priority: counter + 1,
    },
    validationSchema: mediaSchema,
    onSubmit: async (values) => {
      await mutateMedia({
        data: values,
        id: idUser,
      });
    },
  });

  const [count, setCount] = React.useState(0);
  const [textarea, setTextarea] = React.useState(formik.values.description);

  const [countAspect, setCountAspect] = React.useState('countAspect');
  const countAspectRef = React.useRef();
  countAspectRef.current = countAspect;

  const handleSubmit = () => {
    if (!textarea) {
      formik.values.description = ' ';
    } else {
      formik.values.description = textarea;
    }
    formik.handleSubmit();
  };

  return (
    <div className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikTextField
            formik={formik}
            fullWidth
            label="Titre du média"
            name="label"
          />
        </Grid>
        <Grid item xs={12}>
          <FormikTextField
            formik={formik}
            fullWidth
            label={<FormattedMessage id="achievement.type" />}
            name="type"
            select
          >
            {TYPES.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </FormikTextField>
        </Grid>
        <Grid item xs={12}>
          {formik.values.type === 'image' ? (
            <FormLabel>
              <Input
                inputProps={{
                  accept: 'image/*',
                }}
                onChange={(event) => {
                  formik.setFieldValue('attachment', event.target.files[0]);
                }}
                type="file"
              />
            </FormLabel>
          ) : (
            <FormikTextField
              formik={formik}
              fullWidth
              label={<FormattedMessage id="achievement.path" />}
              name="path"
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <div className={css({ width: '100%' })}>
            <CKEditor
              config={{
                wordCount: {
                  onUpdate: (stats) => {
                    setCount(stats.characters);
                  },
                },
                toolbar: [
                  'bold',
                  'italic',
                  'link',
                  'numberedList',
                  'bulletedList',
                  '|',
                  'undo',
                  'redo',
                ],
              }}
              data={textarea}
              editor={Editor}
              onChange={(event, editor) => {
                setTextarea(editor.getData());
                if (count > 500) {
                  setCountAspect('countAspectPassed');
                } else {
                  setCountAspect('countAspect');
                }
              }}
            />
            <div
              style={{ marginTop: spacing(2) }}
              className={classes[countAspectRef.current]}
            >
              {count} / 500
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid className={css({ textAlign: 'center' })} item xs>
              {countAspectRef.current === 'countAspect' ? (
                <Button
                  className={css({ borderRadius: '10.0px' })}
                  color="primary"
                  disabled={isLoading}
                  onClick={handleSubmit}
                  variant="contained"
                >
                  <FormattedMessage id="vitrine.btnCreate" />
                </Button>
              ) : (
                <Button
                  className={css({ borderRadius: '10.0px' })}
                  color="primary"
                  disabled
                  variant="contained"
                >
                  <FormattedMessage id="vitrine.btnCreate" />
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    borderRadius: 10,
  },
  countAspect: {
    color: 'black',
  },
  countAspectPassed: {
    color: 'red',
  },
});

CreateMediaForm.propTypes = {
  close: PropTypes.func,
  data: PropTypes.array,
  refetch: PropTypes.func,
};

export default CreateMediaForm;
